<template>
  <div id="history-settings">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">History</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon small @click="searchNote" color="#3F4360">
        <img
          :src="computeRefreshLogo"
          alt="Refresh"
          class="height-24"
        />
      </v-btn>
    </v-toolbar>
    <v-container style="padding: 0px 24px;">
      <div class="section-bar">
        <v-btn class="filter-btn" dark text v-if="!hasFilter" @click="showTabs">
        <img
          :src="computeFilterLogo"
          alt="Filter"
          class="height-24"
        />
        Filter
      </v-btn>
      <v-btn class="filter-btn-checked" dark text v-else-if="hasFilter && checkedNum === 0" @click="showTabs">
        <img
          :src="computeFilterTagLogo"
          alt="Filter"
          class="height-24"
        />
        Filter
      </v-btn>
      <v-btn class="filter-btn-checked" v-else disabled>
        <div class="checked-num">{{ checkedNum }}</div>
        Filter
      </v-btn>
      <v-text-field
        flat
        solo-inverted
        label="Search the notes"
        prepend-inner-icon="components-icon components-search"
        v-on:keyup.enter="searchNote"
        class="search-field"
        v-model="searchKey"
        hide-details
        color="#5C82E3"
      ></v-text-field>
        <div>
          <span class="section-bar-first" @click="firstLog">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
              <v-btn class="arrow-btn" style="background: #03a9f4; color: #FFF">
                <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                >mdi-arrow-down</v-icon>
              </v-btn>
              </template>
              <span>to bottom</span>
            </v-tooltip>
          </span>
          <span class="section-bar-first" @click="lastLog">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
              <v-btn class="arrow-btn" style="background: #03a9f4; color: #FFF">
                <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                >mdi-arrow-up</v-icon>
              </v-btn>
              </template>
              <span>to top</span>
            </v-tooltip>
          </span>
        </div>
      </div>
      <div class="scroll-container" v-if="showFilterTabs">
        <v-btn icon small v-if="showScrollButtonLeft" @click="handleScroll('left')" class="left-btn">
          <v-icon color="#161A40">chevron_left</v-icon>
        </v-btn>
        <v-btn icon small v-if="showScrollButtonRight" @click="handleScroll('right')" class="right-btn">
          <v-icon color="#161A40">chevron_right</v-icon>
        </v-btn>
        <div ref="parent" class="root">
          <ul class="nav-tabs" ref="scrollContent">
            <li v-for="(item,index) in tabs" :key="index" class="nav-item" @click="clickItem(index)" :class="{active:item.bOn}">{{item.text}}</li>
          </ul>
        </div>
      </div>
      <v-progress-linear v-if="page.isLoading" color="#5C82E3" indeterminate style="margin-top: 8px;"></v-progress-linear>
      <div class="result-text" v-if="hasFilter && checkedNum !== 0"><span class="result-num">{{ resultNum }}</span>Results</div>
      <vue-perfect-scrollbar class="scroll" @ps-y-reach-end="scrollHandler" id="scrollBottom">
        <v-timeline class="timeline" align-top>
          <v-timeline-item right color="#161A40" fill-dot small v-for="(eventLog, index) in eventLogArray" :key="index">
            <template v-slot:icon>
              <v-avatar>
                <div style="width: 8px; height: 8px; border-radius: 50%; background: #fff; border: 2px solid #161A40;"></div>
              </v-avatar>
            </template>
            <span class="operate-time">{{ assist.tool.formatTimeString(eventLog.operatedAt) }}</span>
            <span class="operate-date">{{ assist.tool.formatDate(eventLog.operatedAt) }}</span>
            <v-card class="elevation-2" style="margin-top: 8px; border-radius: 4px; box-shadow: 0px 4px 8px 0px rgba(191, 206, 222, 0.2) !important; overflow: hidden; padding-bottom: 8px;">
              <div class="clear-float">
                <div class="operate-title" v-if="JSON.stringify(assist.dataType.EventLogType).includes(eventLog.logType)">
                  {{ eventLog.logDescription }}
                </div>
                <div class="operate-title" v-else>
                  {{ assist.tool.getEnumTextByValue(assist.dataType.EventTypeEnum, eventLog.logType) }}
                </div>
                <div class="operate-person">
                  <template v-if="isShowOperatedBy">
                    {{ assist.tool.formatOperatedAction(assist.tool.getOperatedNameByEventLog(eventLog)) }}
                  </template>
                  <template v-else>
                    {{ assist.tool.formatOperatedAction(assist.tool.getOperatedActionByEventLog(eventLog, roleList, $store.getters.getAccount)) }}
                  </template>
                </div>
              </div>
              <div class="operate-description">{{ eventLog.eventDescription }}</div>

              <div v-if="eventLog.hasOwnProperty('logData') && assist.tool.isJSON(eventLog.logData)">
                <v-card-text style="padding: 0 16px 8px;">
                  <v-layout wrap v-for="(value, key, index) in JSON.parse(eventLog.logData)" :key="index" class="content-flex">
                    <template v-if="!assist.dataType.eventDataHideEventLog.includes(key)">
                      <!--
                      <v-flex lg4 class="operate-status" v-if="!(assist.tool.adapterKey(key, loan.loanType).includes('Note Content') || assist.tool.adapterKey(key, loan.loanType).includes('Note_content'))">
                        <label :title="assist.tool.adapterKey(key, loan.loanType)">{{ assist.tool.adapterKey(key, loan.loanType) }}</label>
                      </v-flex>
                      -->
                      <v-flex lg12 v-if="key === 'correctionReason'" class="text-right">
                        <v-btn small text @click="showCorrectionReasons(value)" class="more-btn">More Details</v-btn>
                      </v-flex>
                      <v-flex lg12 v-else-if="key === 'searchInfo'">
                        <label v-if="assist.tool.isJSON(value)" :title="JSON.parse(value)[Object.keys(JSON.parse(value))[0]]">
                          <div class="operate-reason" v-html="JSON.parse(value)[Object.keys(JSON.parse(value))[0]]"></div>
                        </label>
                        <label v-else :title="assist.tool.adapterValue(key, value)">
                          <div class="operate-reason" v-html="assist.tool.adapterValueForHtml(key, value)"></div>
                        </label>
                      </v-flex>
                      <v-flex lg12 v-else-if="assist.tool.isNotEmpty(key) && key.toString().indexOf('Url') === -1 && (assist.tool.isNotEmpty(eventLog.diff) && eventLog.diff[0].key === 'Other (Free Text)')">
                        <label title="Other (Free Text)"><div class="operate-reason">Other (Free Text)</div></label>
                      </v-flex>
                      <v-flex lg12 v-else-if="assist.tool.isNotEmpty(key) && key.toString().indexOf('Url') === -1 && key !== assist.dataType.JsonKeyConst.SC_NOTE">
                        <label :title="assist.tool.adapterValue(key, value)"><div class="operate-reason" v-html="assist.tool.adapterValueForHtml(key, value)"></div></label>
                      </v-flex>
                      <v-flex lg12 v-else-if="key !== assist.dataType.JsonKeyConst.SC_NOTE" class="text-right">
                        <v-btn small text :href="value" target="_blank" class="more-btn">Download</v-btn>
                      </v-flex>
                    </template>
                    <v-flex v-if="eventLog.logType === assist.dataType.EventTypeEnum.NOTE_CREATE.value && isShowDeleteNoteLogButton()">
                      <v-btn text small style="background-color: rgba(234, 76, 61, .9); color: #fff" @click="deleteNoteLog(eventLog.id)">Delete</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </div>
              <v-divider v-if="(eventLog.hasOwnProperty('logData') && assist.tool.isJSON(eventLog.logData)) && ((eventLog.hasOwnProperty('diff') && eventLog.diff.length > 0) || (assist.tool.isNotEmpty(eventLog.logType) && eventLog.logType.toString().startsWith('2') && eventLog.hasOwnProperty('documentUrl')) || (eventLog.hasOwnProperty('noteContent')))"></v-divider>
              <div v-if="eventLog.hasOwnProperty('diff') && eventLog.diff.length > 0">
                <v-card-text style="padding: 0 16px 8px;">
                  <v-layout wrap v-for="(diff, index) in eventLog.diff" :key="index">
                    <template v-if="!assist.dataType.diffHideEventLog.includes(diff.key)">
                      <template v-if="diff.key === 'loanStatus' && (typeof diff.current === 'object' || typeof diff.original === 'object')">
                        <v-flex lg4><label title="Loan Status" class="operate-status">Loan Status</label></v-flex>
                        <v-flex lg4>
                          <label class="text-before">Before</label>
                          <label class="operate-reason" v-if="assist.tool.isNotEmpty(diff.original)" :title="assist.tool.getEnumTextByValue(assist.dataType.LoanStatus, diff.original.loanStatus)">
                            {{ assist.tool.getEnumTextByValue(assist.dataType.LoanStatus, diff.original.loanStatus) }}
                          </label>
                        </v-flex>
                        <v-flex lg4>
                          <label class="text-after">After</label>
                          <label class="operate-reason" v-if="assist.tool.isNotEmpty(diff.current)" :title="assist.tool.getEnumTextByValue(assist.dataType.LoanStatus, diff.current.loanStatus)">
                            {{ assist.tool.getEnumTextByValue(assist.dataType.LoanStatus, diff.current.loanStatus) }}
                          </label>
                        </v-flex>
                        <v-flex lg4><label title="Loan Phase" class="operate-status">Loan Phase</label></v-flex>
                        <v-flex lg4>
                          <label class="text-before">Before</label>
                          <label class="operate-reason" v-if="assist.tool.isNotEmpty(diff.original)" :title="assist.tool.getEnumTextByValue(assist.dataType.LoanPhaseEnum, diff.original.phase)">
                            {{ assist.tool.getEnumTextByValue(assist.dataType.LoanPhaseEnum, diff.original.phase) }}
                          </label>
                        </v-flex>
                        <v-flex lg4>
                          <label class="text-after">After</label>
                          <label class="operate-reason" v-if="assist.tool.isNotEmpty(diff.current)" :title="assist.tool.getEnumTextByValue(assist.dataType.LoanPhaseEnum, diff.current.phase)">
                            {{ assist.tool.getEnumTextByValue(assist.dataType.LoanPhaseEnum, diff.current.phase) }}
                          </label>
                        </v-flex>
                      </template>
                      <template v-else>
                        <v-flex lg4 style="height: 24px;">
                          <label v-if="viewKeyArray.includes(diff.key)"><v-btn small text @click="showViewDetails(eventLog)" class="more-btn" color="#5C82E3">view</v-btn></label>
                          <label v-else-if="diff.logType === assist.dataType.EventTypeEnum.INSTANT_LITIGANT_VERIFICATION.value"><div class="operate-reason" style="margin-top: 3px;" :title="assist.tool.adapterValue(diff.key, diff.current)">{{ assist.tool.adapterValue(diff.key, diff.current) }}</div></label>
                          <label v-else-if="diff.logType === assist.dataType.EventTypeEnum.SPECIAL_CONSIDERATION_TAG.value" :title="assist.tool.adapterKey(diff.key, loan.loanType)"><div class="operate-status" style="margin-top: 3px;" v-html="diff.key"></div></label>
                          <label v-else :title="assist.tool.adapterKey(diff.key, loan.loanType)"><div class="operate-status" style="margin-top: 3px;" v-html="assist.tool.adapterKey(diff.key, loan.loanType)"></div></label>
                        </v-flex>
                        <template v-if="moreDetailsKeyArray.includes(diff.key)">
                          <v-flex lg4 style="height: 24px;"><v-btn small text @click="showMoreDetails(diff)" class="more-btn" color="#5C82E3">More Details</v-btn></v-flex>
                          <v-flex lg4 style="height: 24px;"></v-flex>
                        </template>
                        <template v-else-if="diff.logType === assist.dataType.EventTypeEnum.INSTANT_LITIGANT_VERIFICATION.value"></template>
                        <template v-else>
                          <v-flex lg4 v-if="assist.tool.isNotEmpty(diff.key) && diff.key.toString().indexOf('Url') === -1">
                            <label class="text-before">Before</label>
                            <label class="operate-reason" :title="assist.tool.adapterValue(diff.key, diff.original)">{{ assist.tool.adapterValue(diff.key, diff.original) }}</label>
                          </v-flex>
                          <v-flex lg4 v-else class="text-right"><v-btn v-if="assist.tool.isNotEmpty(diff.original)" small text :href="diff.original" target="_blank" class="more-btn">Download</v-btn></v-flex>
                          <v-flex lg4 v-if="assist.tool.isNotEmpty(diff.key) && diff.key.toString().indexOf('Url') === -1">
                            <label class="text-after">After</label>
                            <label class="operate-reason" :title="assist.tool.adapterValue(diff.key, diff.current)">{{ assist.tool.adapterValue(diff.key, diff.current) }}</label>
                          </v-flex>
                          <v-flex lg4 v-else class="text-right"><v-btn v-if="assist.tool.isNotEmpty(diff.current)" small text :href="diff.current" target="_blank" class="more-btn">Download</v-btn></v-flex>
                        </template>
                      </template>
                    </template>
                  </v-layout>
                </v-card-text>
              </div>
              <v-divider v-if="(eventLog.hasOwnProperty('diff') && eventLog.diff.length > 0) && ((assist.tool.isNotEmpty(eventLog.logType) && eventLog.logType.toString().startsWith('2') && eventLog.hasOwnProperty('documentUrl')) || (eventLog.hasOwnProperty('noteContent')))"></v-divider>
              <div v-if="assist.tool.isNotEmpty(eventLog.logType) && eventLog.logType.toString().startsWith('2') && eventLog.hasOwnProperty('documentUrl')">
                <v-card-text style="padding: 0 16px 8px;">
                  <v-layout wrap>
                    <v-flex lg4>
                      <span class="operate-status">{{ assist.tool.getEnumTextByValue(assist.dataType.DocumentTypeEnum, eventLog.documentType) }}</span>
                    </v-flex>
                    <v-flex lg4>
                      <span class="operate-reason" v-if="assist.tool.isNotEmpty(eventLog.documentSize)">{{ eventLog.documentSize + "B" }}</span>
                    </v-flex>
                    <v-flex lg4 class="text-right">
                      <v-btn small text :href="eventLog.documentUrl" class="more-btn">Download</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </div>
              <v-divider v-if="(assist.tool.isNotEmpty(eventLog.logType) && eventLog.logType.toString().startsWith('2') && eventLog.hasOwnProperty('documentUrl')) && (eventLog.hasOwnProperty('noteContent'))"></v-divider>
              <div v-if="eventLog.hasOwnProperty('noteContent')">
                <v-card-text style="word-wrap: break-word; padding: 0 16px 8px;">
                  <h6 class="operate-status">{{ eventLog.noteCategory }}</h6>
                  <div
                    class="operate-reason"
                    v-if="assist.tool.isNotEmpty(eventLog.noteContent)"
                    v-html="eventLog.noteContent.toString().replace(/<br>/ig, '').replace(/\r\n/ig, '<br/>').replace(/\n/ig, '<br/>')"></div>
                </v-card-text>
              </div>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </vue-perfect-scrollbar>
    </v-container>

    <v-dialog v-model="dialog.bankRecordsMoreDetailsDialog.display" persistent max-width="1200px">
      <more-details-dialog
        :diffData="bankRecordsDiffData"
        :headers="diffDataHeaders.BankRecordsMoreDetailsHeader"
        :tableHeight="400"
        @hideDialog="hideBankRecordsMoreDetailsEventHandler"
      ></more-details-dialog>
    </v-dialog>
    <v-dialog v-model="dialog.paymentInstallmentDataMoreDetailsDialog.display" persistent max-width="1600px">
      <more-details-dialog
        :diffData="paymentInstallmentDiffData"
        :headers="diffDataHeaders.PaymentInstallmentMoreDetailsHeader"
        :tableHeight="500"
        :hasBeforeAfter="true"
        @hideDialog="hidePaymentInstallmentDataMoreDetailsEventHandler"
      ></more-details-dialog>
    </v-dialog>
    <v-dialog v-model="dialog.paymentFeeDataMoreDetailsDialog.display" persistent max-width="1600px">
      <more-details-dialog
        :diffData="paymentFeeDiffData"
        :headers="diffDataHeaders.PaymentFeeMoreDetailsHeader"
        :tableHeight="320"
        @hideDialog="hidePaymentFeeDataMoreDetailsEventHandler"
      ></more-details-dialog>
    </v-dialog>
    <v-dialog v-model="dialog.correctionReasonsMoreDetailsDialog.display" persistent max-width="900px">
      <correction-reasons-more-details-dialog
        :correctionReasonsData="correctionReasonsData"
        @hideDialog="hideCorrectionReasonsMoreDetailsEventHandler"
      ></correction-reasons-more-details-dialog>
    </v-dialog>
    <v-dialog v-model="dialog.auditRecordDetailDialog.display" persistent max-width="1600px">
      <more-details-dialog
        :diffData="auditRecordDiffData"
        :headers="tableHeaderLazyLoad.getAuditRecordMoreDetailsHeader()"
        :tableHeight="300"
        @hideDialog="hideAuditRecordMoreDetailsEventHandler"
      ></more-details-dialog>
    </v-dialog>
    <v-dialog v-model="dialog.specialConsiderationLogDialog.display" persistent max-width="600px">
      <v-card max-width="600px">
        <v-toolbar color="primary" dark>
          <span class="headline">Other Reason</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog.specialConsiderationLogDialog.display = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="m-t-20">
          {{ noteContent }}
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              text
              @click="dialog.specialConsiderationLogDialog.display = false"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogQuestion"
        width="512"
        persistent
        class="dialogFlex"
    >
      <div class="question-note" aria-live="assertive" aria-modal="true">
        <div class="swal2-header icon-top"
        >
          <div class="swal2-icon swal2-question swal2-animate-question-icon" style="display: flex">
            <span class="swal2-icon-text">
              ?
            </span>
          </div>
        </div>
        <div class="swal2-content">
          <div id="swal2-content" style="font-family: '等线'; font-size: 20px; font-weight: normal">
            Are you sure delete this log?
          </div>
        </div>
        <div class="swal2-actions" style="display: flex">
          <v-btn
              class="mb-bottom swal2-confirm swal2-styled"
              style="border-left-color: rgba(43, 21, 21, 0); border-right-color: rgba(43, 21, 21, 0);"
              aria-label
              color="primary"
              text
              depressed
              @click="sendDeleteNoteLog"
          >
            OK
          </v-btn>
          <v-btn
              class="mb-bottom swal2-cancel swal2-styled"
              aria-label
              style="display: inline-block;"
              color="primary"
              text
              depressed
              @click="dialogQuestion = false"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { OAuthApi, CollectionApi, PaymentApi } from '@/api/pandaria'
import { DataType, Tool, Authentication } from '@/util/index'
import CorrectionReasonsMoreDetailsDialog from '@/components/panda/common/dialog/CorrectionReasonsMoreDetailsDialog'
import { SystemEnum } from '@/assets/js'
import MoreDetailsDialog from '@/components/panda/common/dialog/MoreDetailsDialog'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import { ListTableHeaderLazyLoad } from '@/setting/list-header/list-table-header-lazy-load'
import filterImg from '@/assets/icons/icon_filter@3x.png'
import filterTagImg from '@/assets/icons/icon_filter_tag@2x.png'
import refreshImg from '@/assets/icons/icon_refresh@3x.png'
const tool = new Tool()
const listTableHeaderLazyLoad = new ListTableHeaderLazyLoad()

export default {
  name: 'history-settings',
  components: {
    CorrectionReasonsMoreDetailsDialog,
    MoreDetailsDialog
  },
  props: {
    loan: Object,
    privileges: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      logTypeList: [],
      resultNum: 0,
      showFilterTabs: false,
      checkedNum: 0,
      hasFilter: false,
      tabs: DataType.HistoryFilterLoanTypeEnum,
      searchKey: '',
      eventLogArray: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        isEnd: true,
        isLoading: true
      },
      assist: {
        tool: new Tool(),
        dataType: DataType,
        systemEnum: SystemEnum
      },
      moreDetailsKeyArray: [
        'bankRecords', 'paymentInstallmentData', 'paymentFeeData', 'items', 'auditRecord'
      ],
      viewKeyArray: ['Other (Free Text)'],
      dialog: {
        bankRecordsMoreDetailsDialog: {
          display: false
        },
        paymentInstallmentDataMoreDetailsDialog: {
          display: false
        },
        paymentFeeDataMoreDetailsDialog: {
          display: false
        },
        correctionReasonsMoreDetailsDialog: {
          display: false
        },
        auditRecordDetailDialog: {
          display: false
        },
        specialConsiderationLogDialog: {
          display: false
        }
      },
      bankRecordsDiffData: [],
      paymentInstallmentDiffData: [],
      paymentFeeDiffData: [],
      auditRecordDiffData: [],
      correctionReasonsData: [],
      roleList: [],
      diffDataHeaders: LIST_TABLE_HEADER,
      tableHeaderLazyLoad: listTableHeaderLazyLoad,
      showScrollButtonLeft: false,
      showScrollButtonRight: false,
      filterType: '',
      noteContent: '',
      dialogQuestion: '',
      noteCreateLogId: null
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    isShowOperatedBy () {
      return Authentication.matchElementPrivilege(this.privileges, DataType.PrivilegeCode.SHOW_OPERATED_BY, DataType.PrivilegeType.EXECUTABLE)
    },
    computeFilterLogo () {
      return filterImg
    },
    computeFilterTagLogo () {
      return filterTagImg
    },
    computeRefreshLogo () {
      return refreshImg
    }
  },
  watch: {
    async loanId () {
      if (!this.isShowOperatedBy) {
        await this.listRole()
      }
      this.initHistorySettings()
    }
  },
  destroyed () {
    this.$eventBus.$off('update-history-settings')
  },
  mounted () {
    this.$eventBus.$on('update-history-settings', target => {
      this.initHistorySettings()
    })
    this.tabs.map(function (value) {
      value.bOn = false
    })
  },
  methods: {
    deleteNoteLog (id) {
      this.noteCreateLogId = id
      this.dialogQuestion = true
    },
    sendDeleteNoteLog () {
      const $this = this
      PaymentApi.deleteNote(this.noteCreateLogId, function () {
        $this.dialogQuestion = false
        $this.eventLogArray = $this.eventLogArray.filter(item => item.id !== $this.noteCreateLogId)
      })
    },
    isShowDeleteNoteLogButton () {
      return Authentication.matchElementPrivilege(this.privileges, DataType.PrivilegeCode.NOTE_CREATE_LOG_DELETE, DataType.PrivilegeType.EXECUTABLE)
    },
    handleScroll (direction) {
      // 每10毫秒移动20，点击一次移动十次,根据自己需要调整
      let times = 0
      const interval = 10
      const moveInterval = 20
      const totalTimes = 10
      const vm = this
      const scroll = () => {
        times++
        const offset = vm.$refs.parent.scrollLeft
        vm.$refs.parent.scrollLeft = direction === 'right' ? offset + moveInterval : offset - moveInterval
        if (times !== totalTimes) {
          setTimeout(scroll, interval)
        }
      }
      scroll()
      if (this.showScrollButtonLeft === true && this.$refs.parent.getBoundingClientRect().left - this.$refs.scrollContent.getBoundingClientRect().left < 65) {
        this.showScrollButtonLeft = false
      } else {
        this.showScrollButtonLeft = true
      }
      if (this.showScrollButtonRight === true && this.$refs.parent.getBoundingClientRect().right - this.$refs.scrollContent.getBoundingClientRect().right > -65) {
        this.showScrollButtonRight = false
      } else {
        this.showScrollButtonRight = true
      }
    },
    showTabs () {
      this.showFilterTabs = !this.showFilterTabs
      this.hasFilter = !this.hasFilter
      this.$nextTick(() => {
        if (this.showFilterTabs) {
          setTimeout(() => {
            const { $refs: { parent, scrollContent } } = this
            // 第一次加载时判断是否需要显示左右滚动按钮，如果父容器的宽度大于子容器的宽度就不用
            if (parent && scrollContent) {
              this.showScrollButtonRight = parent.offsetWidth < scrollContent.offsetWidth
            }
          }, 300)
        }
      })
    },
    clickItem (index) {
      this.checkedNum = 0
      const temp = this.tabs[index]
      temp.bOn = !this.tabs[index].bOn
      this.$set(this.tabs, index, temp)
      this.hasFilter = true
      this.page.pageSize = 10
      this.initHistorySettings()
    },
    searchNote () {
      this.page.pageSize = 10
      this.initHistorySettings()
    },
    async listRole () {
      const $this = this
      $this.roleList = []
      await OAuthApi.listRole(function (result) {
        for (let item of result) {
          if (typeof item === 'string') {
            item = JSON.parse(item)
          }
          $this.roleList.push(item)
        }
      })
    },
    showCorrectionReasons (data) {
      this.correctionReasonsData = data
      this.dialog.correctionReasonsMoreDetailsDialog.display = true
    },
    hideCorrectionReasonsMoreDetailsEventHandler () {
      this.dialog.correctionReasonsMoreDetailsDialog.display = false
    },
    hideAuditRecordMoreDetailsEventHandler () {
      this.dialog.auditRecordDetailDialog.display = false
    },
    hideBankRecordsMoreDetailsEventHandler () {
      this.dialog.bankRecordsMoreDetailsDialog.display = false
    },
    hidePaymentInstallmentDataMoreDetailsEventHandler () {
      this.dialog.paymentInstallmentDataMoreDetailsDialog.display = false
    },
    hidePaymentFeeDataMoreDetailsEventHandler () {
      this.dialog.paymentFeeDataMoreDetailsDialog.display = false
    },
    showViewDetails (eventLog) {
      if (eventLog.diff[0].key === 'Other (Free Text)') {
        this.dialog.specialConsiderationLogDialog.display = true
        this.noteContent = JSON.parse(eventLog.logData).scNote
      }
    },
    showMoreDetails (tableData) {
      let original = []
      let current = []
      let moreDetailsKey = ''
      if (tool.isNotEmpty(tableData)) {
        original = tool.isEmpty(tableData.original) ? [] : tableData.original
        current = tool.isEmpty(tableData.current) ? [] : tableData.current
        moreDetailsKey = tableData.key
      }
      if (!(original instanceof Array)) {
        original = [original]
      }
      if (!(current instanceof Array)) {
        current = [current]
      }
      tableData.original = original
      tableData.current = current
      switch (moreDetailsKey) {
        case 'bankRecords':
          this.bankRecordsDiffData = tableData
          this.dialog.bankRecordsMoreDetailsDialog.display = true
          break
        case 'paymentInstallmentData': case 'items':
          this.paymentInstallmentDiffData = tableData
          this.dialog.paymentInstallmentDataMoreDetailsDialog.display = true
          break
        case 'paymentFeeData':
          this.paymentFeeDiffData = tableData
          this.dialog.paymentFeeDataMoreDetailsDialog.display = true
          break
        case 'auditRecord':
          this.auditRecordDiffData = tableData
          this.dialog.auditRecordDetailDialog.display = true
          break
        default:
          break
      }
    },
    initHistorySettings () {
      this.page.currentPage = 1
      this.eventLogArray = []
      this.listTimeLineByLoanId()
    },
    listTimeLineByLoanId () {
      this.page.isLoading = true
      this.page.isEnd = true
      const $this = this
      for (var i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].bOn) {
          $this.logTypeList.push(this.tabs[i].value)
        }
      }
      const input = {
        loanId: this.loanId,
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        filter: this.searchKey,
        logTypeList: this.logTypeList
      }
      CollectionApi.historyFilterResult(input, function (result) {
        $this.page.isLoading = false
        $this.page.isEnd = tool.isEmpty(result)
        if ($this.page.pageSize === 9999999 && tool.isNotEmpty(result)) {
          $this.page.isEnd = true
          $this.eventLogArray = $this.timelineFilter(result)
          $this.resultNum = $this.eventLogArray.length
          $this.$nextTick(() => {
            const scrollBottom = document.getElementById('scrollBottom')
            scrollBottom.scrollTop = scrollBottom.scrollHeight
          })
        } else {
          $this.eventLogArray = $this.eventLogArray.concat($this.timelineFilter(result))
          $this.resultNum = $this.eventLogArray.length
        }
        $this.logTypeList = []
      }, function (err) {
        $this.$popWarningAlert({ text: tool.isEmpty(err.message) ? 'Failure' : err.message })
      })
    },
    timelineFilter (timelineArray) {
      const newArray = []
      let tmpArray = []
      const loanStatusChangeArray = [DataType.EventTypeEnum.LOAN_STATUS_EVENT.value, DataType.EventTypeEnum.LOAN_STATUS_CHANGE.value, DataType.EventTypeEnum.PPS_TO_LCS.value,
        DataType.EventTypeEnum.TRANSACTION_STATUS_EVENT.value, DataType.EventTypeEnum.TRANSACTION_STATUS_CHANGE.value, DataType.EventTypeEnum.TRANSACTION_AMOUNT_CHANGE.value
      ]

      if (tool.isNotEmpty(timelineArray)) {
        for (let i = 0; i < timelineArray.length; i++) {
          const threadId = timelineArray[i].threadId
          let timeline = timelineArray[i]
          try {
            if (tool.isNotEmpty(timeline.logData)) {
              const logData = JSON.parse(timeline.logData)
              if (tool.isNotEmpty(logData.eventDescription)) {
                timeline.eventDescription = logData.eventDescription
                delete timeline.logData
              }
            }
            if (tool.isEmpty(threadId)) {
              const resultArr = this.convertFormatToDiff(timeline)
              timeline = this.judgeDiffResult(resultArr, tmpArray, timeline)
              newArray.push(timeline)
              tmpArray = []
            } else {
              if (loanStatusChangeArray.includes(timeline.logType)) {
                const resultArr = this.convertFormatToDiff(timeline)
                timeline = this.judgeDiffResult(resultArr, tmpArray, timeline)
                newArray.push(timeline)
                tmpArray = []
              } else {
                if (i === timelineArray.length - 1) {
                  const resultArr = this.convertFormatToDiff(timeline)
                  timeline = this.judgeDiffResult(resultArr, tmpArray, timeline)
                  newArray.push(timeline)
                  tmpArray = []
                  break
                }
                const resultArr = this.convertFormatToDiff(timeline)
                timeline = this.judgeDiffResult(resultArr, tmpArray, timeline)
                newArray.push(timeline)
                tmpArray = []
              }
            }
          } catch (err) {
            console.error(err.message)
            continue
          }
        }
      }
      return newArray
    },
    judgeDiffResult (resultArr, tmpArray, timeline) {
      tmpArray = []
      for (let i = 0; i < resultArr.length; ++i) {
        tmpArray.push(resultArr[i])
      }
      if (tool.isNotEmpty(tmpArray)) {
        timeline.diff = tmpArray
      }
      tmpArray.map(item => {
        if (item.logType === DataType.EventTypeEnum.INSTANT_LITIGANT_VERIFICATION.value && item.key === 'status') {
          timeline.diff = [item]
        }
      })
      return timeline
    },
    convertFormatToDiff (incomingData) {
      const keySet = []
      const resultArray = []
      const original = tool.isEmpty(incomingData.original) ? {} : JSON.parse(incomingData.original)
      const current = tool.isEmpty(incomingData.current) ? {} : JSON.parse(incomingData.current)
      const logType = tool.isEmpty(incomingData.logType) ? {} : JSON.parse(incomingData.logType)

      for (const key in original) {
        keySet.push(key)
      }

      for (const key in current) {
        if (!keySet.includes(key)) {
          keySet.push(key)
        }
      }

      for (const key of keySet) {
        const returnObj = {}
        returnObj.key = key
        returnObj.original = (tool.isEmpty(original) || tool.isEmpty(original[key])) ? '' : original[key]
        returnObj.current = (tool.isEmpty(current) || tool.isEmpty(current[key])) ? '' : current[key]
        returnObj.logType = logType
        resultArray.push(returnObj)
      }
      return resultArray
    },
    scrollHandler () {
      if (!this.page.isEnd) {
        this.page.currentPage++
        this.page.pageSize = 10
        this.listTimeLineByLoanId()
      }
    },
    firstLog () {
      this.page.pageSize = 9999999
      if (!this.page.isEnd) {
        this.initHistorySettings()
      } else {
        this.$nextTick(() => {
          const scrollBottom = document.getElementById('scrollBottom')
          scrollBottom.scrollTop = scrollBottom.scrollHeight
        })
      }
    },
    lastLog () {
      this.$nextTick(() => {
        const scrollBottom = document.getElementById('scrollBottom')
        scrollBottom.scrollTop = 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: none;
  }
  .filter-btn {
    color: #FFF;
    background: #03a9f4;
    border-radius: 2px;
    box-shadow: 0px 4px 8px 0px rgba(101, 110, 132, 0.2);
    width: 96px;
    height: 36px;
    font-size: 14px;
    font-weight:  400;
    line-height: 18px;
    text-transform: none;
    font-family: 'Montserrat';
  }
  .filter-btn-checked {
    color: #50525F;
    background: #F9FAFD;
    border-radius: 2px;
    border: 1px solid #BBBECD;
    width: 96px;
    height: 36px;
    font-size: 14px;
    font-weight:  400;
    line-height: 18px;
    text-transform: none;
    font-family: 'Montserrat';
  }
  .section-bar-first {
    color: #50525F;
    background: #03a9f4;
    border-radius: 2px;
    width: 96px;
    height: 36px;
    font-size: 14px;
    font-weight:  400;
    line-height: 18px;
    text-transform: none;
    margin-left: 5px;
  }
  .checked-num {
    background: #EB5757;
    color: #FFF;
    border-radius: 50%;
    font-size: 12px;
    font-weight:  500;
    line-height: 16px;
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }
  .result-text {
    color: #2F80ED;
    border-radius: 50%;
    font-size: 12px;
    font-weight:  500;
    line-height: 16px;
    position: relative;
    top: 16px;
  }
  .result-num {
    color: #2F80ED;
    border-radius: 50%;
    font-size: 14px;
    font-weight:  500;
    line-height: 18px;
    margin-right: 4px;
  }
  .search-field {
    display: inline-block;
    height: 36px;
    // width: 680px;
    //width: calc(100% - 112px);
    margin-left: 16px;
    font-family: 'Montserrat';
  }
  .operate-time {
    font-size: 12px;
    // height: 16px;
    line-height: 16px;
    font-weight: 500;
    color: #7E829B;
    margin-right: 8px;
    position: relative;
    top: -6px;
    font-family: 'Montserrat';
  }
  .operate-date {
    font-size: 12px;
    // height: 16px;
    line-height: 16px;
    font-weight: 400;
    color: #7E829B;
    position: relative;
    top: -6px;
    font-family: 'Montserrat';
  }
  .operate-title {
    display: inline-block;
    font-size: 16px;
    // height: 20px;
    line-height: 20px;
    font-weight: 600;
    color: #161A40;
    position: absolute;
    top: 0;
    left: 16px;
    margin: 16px 0;
    font-family: 'Montserrat';
  }
  .operate-person {
    display: inline-block;
    font-size: 14px;
    // height: 18px;
    line-height: 18px;
    font-weight: 500;
    color: #7E829B;
    position: absolute;
    top: 0;
    right: 16px;
    margin: 16px 0;
    font-family: 'Montserrat';
  }
  .clear-float:after {
    content: " ";
    clear: both;
    display: block;
    visibility: hidden;
    height: 48px;
  }
  .operate-description {
    font-size: 14px;
    // height: 18px;
    line-height: 18px;
    font-weight: 400;
    color: #3F4360;
    font-family: 'Montserrat';
    margin: -8px 16px 8px;
  }
  .operate-reason {
    font-size: 14px;
    // height: 18px;
    line-height: 18px;
    font-weight: 500;
    color: #3F4360;
    font-family: 'Montserrat';
  }
  .operate-status {
    font-size: 14px;
    // height: 18px;
    line-height: 18px;
    font-weight: 500;
    color: #7E829B;
    font-family: 'Montserrat';
  }
  .more-btn {
    color: #5C82E3;
    background: #DEE6F9;
    border-radius: 2px;
    height: 24px !important;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-transform: none;
    font-family: 'Montserrat';
    padding: 0 8px !important;
  }
  .text-before {
    color: #E76868;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-right: 8px;
    font-family: 'Montserrat';
  }
  .text-after {
    color: #64CA99;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-right: 8px;
    font-family: 'Montserrat';
  }
  .timeline .v-divider {
    display: block;
    flex: 1 1 0px;
    max-width: 100%;
    height: 0px;
    max-height: 0px;
    border: solid;
    border-width: 1px 0 0 0;
    transition: inherit;
    border-top-color: #E8EBF5 !important;
    margin: 0 16px 8px;
  }
  .nav-tabs{
    height: 42px;
    list-style: none;
    margin: 0px;
    padding: 16px 0;
    width: auto;
    // overflow-x: auto;
    display: inline-block;
    white-space: nowrap;
    background: #F9FAFD;
  }
  .nav-item {
    background: #E5F0FF;
    color: #24252E;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    padding: 8px;
    text-align: center;
    display: inline;
    margin: 0 4px 0;
    border-radius: 16px;
  }
  .nav-item.active {
    background: #2F80ED;
    color: #FFF;
    box-shadow: 0px 4px 8px 0px rgba(101, 110, 132, 0.2);
  }
  .nav-item:hover {
    background: #F2F5FD;
    color: #2F80ED;
    box-shadow: none;
  }
  .scroll {
    height: calc(100vh - 220px);
    width: 100%;
    margin-top: 32px;
  }
  .scroll-container {
    position: relative;
  }
  .left-btn {
    position: absolute;
    left: 0px;
    top: 12px;
    background: #fff;
    box-shadow: 0px 4px 8px 0px rgba(132, 146, 182, 0.4);
  }
  .right-btn {
    position: absolute;
    right: 0px;
    top: 12px;
    background: #fff;
  }
  .root {
    overflow-x: auto;
    scrollbar-width: none; // Firefox隐藏滚动条
  }
  .root::-webkit-scrollbar {
    display: none; // Chrome隐藏滚动条
  }
</style>
<style lang="css">
  .toolbar-card .v-toolbar__content {
    padding: 24px;
    height: 80px !important;
  }
  .toolbar-card .v-toolbar__content > .v-btn.v-btn--icon:last-child {
    margin-right: 0px !important;
  }
  .search-field.v-text-field.v-text-field--solo .v-input__control {
    min-height: 36px;
    border-radius: 2px;
  }
  .search-field.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 8px;
  }
  .search-field .v-input__control .v-input__prepend-inner {
    padding-right: 8px;
  }
  .search-field .v-input__control .v-text-field__slot .v-label {
    color: #C4C7D8;
    font-size: 12px;
    font-weight: 400;
    height: 16px;
    line-height: 16px;
    font-family: 'Montserrat';
  }
  .search-field .v-input__control > .v-input__slot {
    background: #F2F5FD !important;
    border: 1px solid transparent;
  }
  .search-field.theme--light.v-text-field--solo-inverted.v-input--is-focused > .v-input__control > .v-input__slot input {
    color: #24252E;
  }
  .search-field.theme--light.v-text-field--solo-inverted.v-input--is-focused > .v-input__control > .v-input__slot {
    background: #FFF !important;
    border: 1px solid rgba(47, 128, 237, 0.2);
  }
  .search-field.theme--light.v-text-field--solo-inverted.v-input--is-label-active .v-input__control .v-input__slot input, .search-field.theme--light.v-text-field--solo-inverted.v-input--is-dirty .v-input__control .v-input__slot input {
    color: #24252E;
    font-size: 12px;
    font-weight: 400;
    height: 16px;
    line-height: 16px;
    font-family: 'Montserrat';
  }
  .timeline .v-timeline-item__dot--small {
    height: 8px;
    left: calc(50% + 1px);
    width: 8px;
    position: absolute;
  }
  .timeline .v-timeline-item__divider {
    position: relative;
    min-width: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 19px;
  }
  .timeline .v-timeline-item__body {
    position: relative;
    height: 100%;
    flex: 1 1 auto;
    left: 0px;
  }
  .timeline .v-timeline-item__body > .v-card:not(.v-card--flat):before, .v-timeline-item__body > .v-card:not(.v-card--flat):after {
    content: "";
    position: absolute;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: none;
    top: calc(50% - 10px);
  }
  .timeline.v-timeline {
    padding-top: 0px;
    position: relative;
  }

  #history-settings .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse):before {
    left: calc(15% - 116px) !important;
    right: initial;
  }
  #history-settings .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:not(.v-timeline-item--before) .v-timeline-item__body {
    min-width: 764px !important;
  }
  .toolbar-title .theme--dark.v-sheet {
    color: #1f2a8d;
  }
  .section-bar {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .arrow-btn {
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2);
    height: 36px;
    font-weight:  400;
    line-height: 18px;
    text-transform: none;
    font-family: 'Montserrat';
  }
  .content-flex {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap !important;
    align-items: center;
  }
  .question-note {
    height: 290px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    text-align: center;
    background-color: #fff;
  }
  .icon-top {
    margin-top: 40px;
  }
  .mb-bottom {
    margin-bottom: 20px;
  }
</style>
